import { Divider, IconButton, ListItem, Tooltip, Typography, ListItemSecondaryAction } from '@material-ui/core';
import React, { useState } from 'react';
import { convertToLocalDate } from '../../../utils/date';
import ListItemText from '@material-ui/core/ListItemText';

import { NavLink } from 'react-router-dom';
import MarkunreadOutlinedIcon from '@material-ui/icons/MarkunreadOutlined';
import DraftsOutlinedIcon from '@material-ui/icons/DraftsOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
// import moment from 'moment';
import { apiPostNoLoader } from '../../../utils/api_service';
import { API_URL } from '../../../constants/api';
import { ShowToast, toastType } from '../../../utils/toast-service';
import { getNotificationMasterData } from '../../../store/layout/actions';

function PendingNotification(props) {
  const [read, setRead] = useState({ readNotification: props.isRead });
  // const [action, setAction] = useState('');
  // console.log(props);

  const handleChange = (event) => {
    setRead({
      ...read,
      [event.target.name]: event.target.checked
    });
  };

  const handleRead = (actions) => {
    if (actions.toLowerCase() === 'delete') {
      readNotification(actions);
    } else {
      setRead({
        ...read,
        readNotification: !read.readNotification
      });
      // setAction(actions);

      readNotification(actions);
    }
  };

  const readNotification = (actions) => {
    const params = {
      notificationId: props.recordId,
      isDeleteAll: false,
      action: actions
    };
    apiPostNoLoader({
      url: API_URL.Dashboard.UpdateNotificationAction,
      params: {},
      postBody: params
    }).then((response) => {
      // console.log(response)
      if (response.success) {
        if (actions.toLowerCase() === 'delete') {
          ShowToast('Notification deleted successfully', toastType.SUCCESS, 2000, 500);
        } else if (actions.toLowerCase() === 'read') {
          ShowToast('Notification marked as read ', toastType.SUCCESS, 2000, 500);
        } else if (actions.toLowerCase() === 'unread') {
          ShowToast('Notification marked as unread ', toastType.SUCCESS, 2000, 500);
        }
        props.handleRefresh();
        // setIsAll(false);
        // props.handleRefresh();
        getNotificationMasterData();
      } else {
        ShowToast('Something went wrong.', toastType.ERROR, 5000, 500);
      }
    });
  };
  const [textLength, setTextLength] = useState(10);

  const weight = read.readNotification ? '400' : '800';
  const path = props.module === 'Employee Termination' ? '/employeeTerminations' : '/pendingRequests';
  return (
    <div key={props.recordId} className='pending-notification-box'>
      {/* <h1>{props.header}</h1>
            <p>{props.message}</p> */}
      <div className={read.readNotification ? 'pending-notification-items' : 'pending-notification-items-unread'}>
        {/* <FormGroup row>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={read.readNotification}
                                onChange={handleChange}
                                name="readNotification"
                                color="primary"
                            />
                        }
                        // label={!read.readNotification ? <p style={{display: 'inline'}}>Mark as Read</p> : <p style={{display: 'inline'}}>Mark as UnRead</p>}
                    />
                </FormGroup> */}
        <>
          <ListItem alignItems="flex-start">
            <ListItemText className="approval-text notification-heading" style={{ fontWeight: weight + ' !important' }} primary={<Typography type="body2" style={{ fontWeight: weight, fontSize: '0.9rem !important' }}>{props.header}</Typography>}
              secondary={
                <NavLink style={{ cursor: 'pointer' }}
                  to={{ pathname: '/pendingRequests', navProps: { selectedRow: props } }}>
                  <div className='notification-description' onClick={props.onClick}>
                    {/* <span style={{ cursor: 'pointer', fontWeight: weight }} onClick={() => { setTextLength(200); }}>
                      {props.message !== null ? props.message : '-'}
                      {props.message && props.message.length > textLength ? props.message.substring(0, 37) + '...' : props.message}
                    </span> */}
                    {props.message.indexOf('(Review') === -1 &&
                      <span style={{ fontWeight: weight }}>
                        {props.message !== null ? props.message : '-'}
                      </span>
                    }
                    {props.message.indexOf('(Review') !== -1 &&
                      <>
                        <span style={{ fontWeight: weight }}>
                          {props.message.split('(Review')[0]}
                        </span>
                        <span style={{ fontWeight: weight }}>
                          {props.message.slice(props.message.indexOf('(Review'))}
                        </span>
                      </>
                    }
                    <span style={{ fontSize: '0.5rem !important', fontWeight: weight }}>Created By : {props.createdBy ? props.createdBy : '-'}</span>
                    <span style={{ fontSize: '0.5rem !important', fontWeight: weight }}>Created On: {props.createdDate ? convertToLocalDate(props.createdDate, 'MM-DD-YYYY hh:mm A') : '-'}</span>
                  </div>
                </NavLink>} />
            <ListItemSecondaryAction>
              {/* <NavLink to={'/pendingRequests'} style={{ color: '#FFF', fontSize: 'small' }}>
                      <IconButton edge="end" aria-label="View" title="View" size="small">
                        <VisibilityIcon size="small" />
                      </IconButton>{' '}
                    </NavLink> */}
            </ListItemSecondaryAction>
          </ListItem>
        </>
        {/* <DeleteIcon style={{ cursor: 'pointer' }} /> */}
        <div className="notification-buttons">
          <Tooltip title={read.readNotification ? 'Read' : 'Unread'}>
            <IconButton
              className=""
              variant="contained"
              size="small"
              component="label"
            >
              {read.readNotification && <DraftsOutlinedIcon onClick={() => handleRead('UnRead')} />}
              {!read.readNotification && <MarkunreadOutlinedIcon onClick={() => handleRead('Read')} />}
            </IconButton>
          </Tooltip><Tooltip title="Delete Notification">
            <IconButton
              className=""
              variant="contained"
              size="small"
              component="label"
            >
              <DeleteOutlinedIcon style={{ cursor: 'pointer', color: 'red' }} onClick={() => handleRead('Delete')} />
            </IconButton>
          </Tooltip>
          {/* {props.isClickable && <NavLink key={props.recordId} style={{ cursor: 'pointer', fontSize: '0.768rem' }} to={'/pendingRequests'}> */}
          {/* {props.isClickable && <NavLink key={props.recordId} style={{ cursor: 'pointer', fontSize: '0.768rem' }} to={'/pendingRequests?parentRecordId=' + props.parentRecordId + '&module=' + props.module + '&feature=' + props.header}> */}
          {props.isClickable &&
            <NavLink key={props.recordId} style={{ cursor: 'pointer', fontSize: '0.768rem' }}
              //to={{ pathname: '/pendingRequests', navProps: { selectedRow: props } }}>
              to={{ pathname: path, navProps: { selectedRow: props } }}>
              <div className='pending-notification-icons'>
                <Tooltip title="View Details">
                  <IconButton
                    className=""
                    variant="contained"
                    size="small"
                    component="label"
                  >
                    <VisibilityOutlinedIcon style={{ cursor: 'pointer' }} onClick={props.onClick} />
                  </IconButton>
                </Tooltip>
              </div>
            </NavLink>}
        </div>
      </div>
      <Divider component="li" />
    </div>
  );
}

export default PendingNotification;
